import React, { useEffect, useRef, useState, useContext } from "react";
import { GameDataContext } from "../providers/GameDataProvider";
import { CommunityDragonContext } from "../providers/CommunityDragonProvider";
import EventCard from "./EventCard";
import WinrateContributionChartMini from "./WinrateContributionChartMini";
import WinrateLineChartMini from "./WinrateLineChartMini";
import { formatWinrate, getWinrateColor, getAggregatedEvents, getWinrateContributions } from "../utils/utils";
var Events = function (_a) {
    var _b, _c, _d;
    var setIndex = _a.setIndex, selectedIndexes = _a.selectedIndexes;
    var gameData = useContext(GameDataContext);
    var championSummary = useContext(CommunityDragonContext).championSummary;
    var scrollContainerRef = useRef(null);
    var wholeContainerRef = useRef(null);
    var _e = useState(-1), i = _e[0], setI = _e[1];
    useEffect(function () {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollLeft = 0;
        }
    }, [selectedIndexes]);
    useEffect(function () {
        var scrollContainer = scrollContainerRef.current;
        var wholeContainer = wholeContainerRef.current;
        var handleWheel = function (event) {
            event.preventDefault();
            scrollContainer.scrollLeft += event.deltaY;
        };
        var handleScroll = function () {
            var cards = scrollContainer.querySelectorAll('.event-card');
            var lastOffIndex = -1;
            cards.forEach(function (card, index) {
                var rect = card.getBoundingClientRect();
                var containerRect = scrollContainer.getBoundingClientRect();
                if (rect.right - 100 <= containerRect.left) {
                    lastOffIndex = index;
                }
            });
            setI(lastOffIndex);
        };
        wholeContainer.addEventListener('wheel', handleWheel);
        scrollContainer.addEventListener('scroll', handleScroll);
        return function () {
            wholeContainer.removeEventListener('wheel', handleWheel);
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, []);
    if (!gameData) {
        return null;
    }
    var aggEvents = getAggregatedEvents(gameData.events);
    var filteredAggEvents = selectedIndexes.length > 0 ? selectedIndexes.map(function (index) { return aggEvents[index]; }) : aggEvents;
    var lastAggEvent = (_b = filteredAggEvents[i]) !== null && _b !== void 0 ? _b : [];
    var pastAggEvents = aggEvents.slice(0, aggEvents.indexOf(lastAggEvent) + 1);
    var winrateContributions = getWinrateContributions(pastAggEvents, gameData.allyRoles, gameData.playerTeam);
    var lastEventTime = (_d = (_c = lastAggEvent[lastAggEvent.length - 1]) === null || _c === void 0 ? void 0 : _c.time) !== null && _d !== void 0 ? _d : 0;
    var pastSnapshots = [];
    var pastWinrates = [];
    for (var i_1 = 0; i_1 < gameData.snapshots.length; i_1++) {
        var snapshot = gameData.snapshots[i_1];
        var winrate = gameData.snapshots[i_1].winrate;
        pastSnapshots.push(snapshot);
        pastWinrates.push(winrate);
        if (snapshot.time >= lastEventTime) {
            break;
        }
    }
    var lastWinrate = pastWinrates[pastWinrates.length - 1];
    var handleCardClick = function (index, aggEvent) {
        var cardElement = scrollContainerRef.current.children[index];
        if (cardElement) {
            scrollContainerRef.current.scrollTo({ left: cardElement.offsetLeft - scrollContainerRef.current.offsetLeft + cardElement.offsetWidth - 99, behavior: 'smooth' });
        }
        setIndex(Math.max(gameData.snapshots.findIndex(function (snapshot) { return snapshot.time >= aggEvent[0].time; }) - 1, 0));
    };
    return (React.createElement("div", { ref: wholeContainerRef, style: { width: '100%', height: '100%', display: 'flex', flexDirection: 'column' } },
        React.createElement("div", { style: { width: '100%', height: 100, display: 'flex', justifyContent: 'flex-start', alignItems: 'center' } },
            React.createElement("div", { style: { width: 100, minWidth: 100, height: '100%', display: 'flex', marginLeft: 20, justifyContent: 'center', alignItems: 'center', fontSize: 24, fontWeight: 600, color: getWinrateColor(lastWinrate) } },
                formatWinrate(lastWinrate),
                "%"),
            React.createElement(WinrateLineChartMini, { allyTeam: gameData.playerTeam, snapshots: pastSnapshots, winrates: pastWinrates, maxTime: gameData.snapshots[gameData.snapshots.length - 1].time })),
        React.createElement("div", { style: { width: '100%', height: 300, display: 'flex' } },
            React.createElement("div", { style: { width: 250, minWidth: 250, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                React.createElement(WinrateContributionChartMini, { playerTeam: gameData.playerTeam, allyRoles: gameData.allyRoles, winrateContributions: winrateContributions, iconDim: 20 })),
            React.createElement("div", { ref: scrollContainerRef, style: { width: '100%', minWidth: 0, height: '100%', display: 'flex', alignItems: 'center', overflowX: 'auto', overflowY: 'hidden', marginLeft: 25, paddingLeft: 5 } },
                filteredAggEvents.map(function (aggEvent, i) { return (React.createElement("div", { key: i, className: "event-card", style: { marginLeft: i === 0 ? 0 : 20 }, onClick: function () { return handleCardClick(i, aggEvent); } },
                    React.createElement(EventCard, { gameData: gameData, aggEvent: aggEvent, championSummary: championSummary }))); }),
                React.createElement("div", { style: { width: '100%', flexShrink: 0 } })))));
};
export default Events;
